import { render, staticRenderFns } from "./CKEditorWrapper.vue?vue&type=template&id=66a55f4c&scoped=true&"
import script from "./CKEditorWrapper.vue?vue&type=script&lang=js&"
export * from "./CKEditorWrapper.vue?vue&type=script&lang=js&"
import style0 from "./CKEditorWrapper.vue?vue&type=style&index=0&id=66a55f4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a55f4c",
  null
  
)

export default component.exports